import { AuthPort } from '../ports/AuthPort';

export class RequestPasswordResetUseCase {
  constructor(private authPort: AuthPort) {}

  async execute(email: string): Promise<void> {
    await this.authPort.resetPassword(email);
  }
}
